module.exports = __webpack_public_path__ + "../resources/img/ic_arrow_up_primary.34238c85.svg";